import { Form, FormFieldType } from "../Form";

export class PropertyGeneralDataForm extends Form {
  protected definition = {
    name: { type: FormFieldType.Text, required: true },
    description: { type: FormFieldType.Text, required: false }
  };
}
